import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const importCSV = (payload: FormData): Promise<Response> => {
  const uri = `${API_URL}/recipes/import`;

  return fetch(uri, {
    method: 'POST',
    cache: 'reload',
    body: payload,
  });
};
